import Link from 'next/link'

import StaticNaverMap from '@/components/map/components/staticNaverMap'

import Button from '@/shared/components/button/Button'
import Icons from '@/shared/components/icon/Icons'
import { Caption, Text, Tint } from '@/shared/components/typography'
import useHash from '@/shared/hooks/useHash'

type LocationProps = {
  parkinglotSeq: number
  parkinglotName: string
  address: string
  lat: number
  lng: number
  type: string
  onClick: () => void
  onCopy: () => void
  setIsDetailMapOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const Location = ({
  parkinglotSeq,
  parkinglotName,
  address,
  lat,
  lng,
  type,
  onClick,
  onCopy,
  setIsDetailMapOpen
}: LocationProps) => {
  const { getHashAll } = useHash()
  const hash = getHashAll()
  return (
    <section className="section mb-[24px] flex flex-col gap-3 px-4">
      <div>
        {parkinglotName && (
          <Link
            href={`/map?type=${type}&id=${parkinglotSeq}${hash}`}
            className="inline-flex cursor-pointer items-center"
          >
            <Text level="text3" color="text090" weight="bold">
              {parkinglotName}
            </Text>
            <Icons.RightIcon stroke="currentColor" color="#263238" />
          </Link>
        )}

        <br />
        {address && (
          <div className="inline-flex cursor-pointer items-center gap-1.5" onClick={onCopy}>
            <Caption level="caption2" color="text070">
              {address}
            </Caption>
            <Icons.CopyIcon stroke="currentColor" color="#6D7D90" />
          </div>
        )}
      </div>

      <div
        className="border-lg relative h-[148px] w-full cursor-pointer"
        onClick={() => {
          setIsDetailMapOpen(true)
        }}
      >
        <StaticNaverMap lat={lat} lng={lng} styles={{ border: '1px solid #DEE4E9', borderRadius: '6px' }} />
        <div className="absolute bottom-[10px] right-[12px] flex h-[22px] w-[60px] items-center justify-center rounded bg-dim-050 pt-[2px]">
          <Tint level="tint1" color="white" weight="regular">
            위치 보기
          </Tint>
        </div>
      </div>

      <Button color="text090" text="로드뷰 보기" border="border030" onClick={onClick} className="py-[9px]" />
    </section>
  )
}

export default Location
